import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 20.5C0 9.47207 8.97206 0.5 20 0.5C31.0279 0.5 40 9.47207 40 20.5C40 31.5279 31.0279 40.5 20 40.5C8.97206 40.5 0 31.5279 0 20.5ZM37 20.5C37 11.0934 29.4066 3.5 20 3.5C10.5934 3.5 3 11.0934 3 20.5C3 29.9066 10.5934 37.5 20 37.5C29.4066 37.5 37 29.9066 37 20.5ZM20.0238 10.5C21.101 10.5 21.9723 11.395 21.9406 12.4723L21.6238 23.5297C21.6 24.401 20.8872 25.0901 20.0159 25.0901C19.1446 25.0901 18.4317 24.3931 18.408 23.5297L18.099 12.4723C18.0753 11.395 18.9387 10.5 20.0238 10.5ZM20 30.5C18.899 30.5 18.004 29.6049 18.004 28.504C18.004 27.403 18.899 26.5079 20 26.5079C21.101 26.5079 21.9961 27.403 21.9961 28.504C21.9961 29.6049 21.101 30.5 20 30.5Z",
		fill: "#EC5765"
	})
});
export default SvgWarningCircle;
